import type { ShortcutSearchHit } from "./types";
import { toFileOverview, toFilePreview } from "ls/router/builders";
import { isDiskoProject, isRpProject } from "../files/utils";

export function getFileHref(file: ShortcutSearchHit) {
  switch (file.kind) {
    case "rp":
      return toFilePreview(file.metadata, file.deepInfo?.pageId);
    case "comment":
      return getCommentHref(file);
    default:
      return getHref(file);
  }
}

function getCommentHref(file: ShortcutSearchHit) {
  if (isDiskoProject(file.metadata)) {
    return toFileOverview(file.metadata, { comment: file.deepInfo?.issueCode });
  }
  return toFilePreview(file.metadata, file.deepInfo?.pageId, { comment: file.deepInfo?.issueCode });
}

function getHref(file: ShortcutSearchHit) {
  if (isRpProject(file.metadata) && file.deepInfo?.pageId) {
    return toFilePreview(file.metadata, file.deepInfo?.pageId);
  }
  return toFileOverview(file.metadata, { comment: file.deepInfo?.issueCode, object: file.deepInfo?.objectId, node: file.deepInfo?.nodeId });
}
